import React, { useEffect, useState, ReactNode, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, round } from 'lodash';

import './scss/huring.scss';
import SubTitle from '../component/sub-title';
import Color from '@/tool/color';

import Tab from '../component/tab';
import TimeTab from '../component/time-tab';
import moHuring, { huringActiveChange } from './store/huring';
import HuringChart from './component/huring-chart';
import HeadTable from '../component/head-table';
import Empty from '@/component/empty';
import { toJS } from 'mobx';
import { exportExcelFile } from '@/tool';

interface IProps {}
interface IState {}

const HuringRevenue = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { huringActiveShow, huringList } = moHuring;

  const changeShow = (val: string) => {
    huringActiveChange(val);
  };

  const goInsight = () => {
    window.open('/market/insight', '_blank');
  };

  const titleList = useMemo(() => {
    const list: any = [];
    huringList?.forEach((res: any) => {
      list.push(res.company_name);
    });
    return list;
  }, [huringList]);

  const tableList = useMemo(() => {
    let list: any = [];
    if (!isEmpty(huringList)) {
      list = huringList[0].data.map((res: any, r: any) => {
        const item: any = {};
        item.industry = res.quarter;
        const subList: any = [];
        huringList.forEach((ele: any) => {
          subList.push({
            revenue: ele.data[r].revenue,
            count: ele.data[r].count,
          });
        });
        item.child = subList;
        return item;
      });
    }
    return list;
  }, [huringList]);

  const exporttable = () => {
    const merge: any = [];
    const company: any = [''];
    const year: any = ['年份'];
    titleList?.forEach((item: any, i: number) => {
      company.push(item);
      company.push('');
      year.push('营业收入(亿元)');
      year.push('招聘量(个))');
      merge.push({ s: { r: 0, c: 2 * i + 1 }, e: { r: 0, c: 2 * i + 2 } });
    });
    const content: any = [];
    tableList.forEach((item: any) => {
      const items: any = [item.industry];
      item.child?.forEach((ele: any) => {
        items.push(round(ele.revenue, 2));
        items.push(ele.count);
      });
      content.push(items);
    });
    const list: any = [company, year, ...content];
    exportExcelFile(list, merge, '招聘量与营收');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="effect07" className="huring-revenue-warp human-common">
      <SubTitle
        title="招聘量与营收"
        subtitle="我所在行业前三名"
        bg={Color.primaryColor(0.1)}
        color={Color.primary}
        active={huringActiveShow}
        tabChange={changeShow}/>

      {huringActiveShow === 'chart' ? (
        !isEmpty(huringList) ? (
          <section className="huring-content">
            {huringList?.map((res: any, r: any) => {
              return (
                <section
                  key={`${r}`}
                  className="huring-content-item"
                  style={{ width: `${100 / huringList.length}%` }}>
                  <p className="title">{res.company_name}</p>
                  <HuringChart list={res.data} key={`${r}`} />
                </section>
              );
            })}
          </section>
        ) : (
          <Empty />
        )
      ) : (
        <section>
          {huringActiveShow === 'table' && (
            <section onClick={exporttable} className="export-table">
              导出excel
            </section>
          )}
          {!isEmpty(huringList) && !isEmpty(tableList) ? (
            <HeadTable
              subList={['营业收入(亿元)', '招聘量(个)']}
              emeuList={['revenue', 'count']}
              oneList={['年份']}
              emeuoneList={['industry']}
              list={tableList}
              title={titleList}
              width={100 / huringList.length}
              ratio={2}/>
          ) : (
            <Empty />
          )}
        </section>
      )}

      <section className="huring-banner" onClick={goInsight}>
        <img
          src="https://file.smartsalary.cn/web-img%402.0/home/1012.png"
          alt=""/>
        <img
          src="https://file.smartsalary.cn/web-img%402.0/home/1010.png"
          alt=""/>
      </section>
    </section>
  );
};

export default observer(HuringRevenue);
